import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => {
  return {
    fullWidthContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      width: 810,
      height: '80vh',
    },
    containerPadding: { padding: '0px 20px 20px' },
    containerSetting: {
      paddingTop: 50,
    },
  };
});
